var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstDealImage2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 2.7998L25.8606 4.991C26.409 5.1134 26.8002 5.5994 26.8002 6.1622V18.1466C26.8002 20.5538 25.5966 22.8026 23.5938 24.137L16.0002 29.1998L8.4066 24.137C6.4026 22.8014 5.2002 20.5538 5.2002 18.1478V6.1622C5.2002 5.5994 5.5914 5.1134 6.1398 4.991L16.0002 2.7998ZM16.0002 5.2586L7.6002 7.1246V18.1466C7.6002 19.751 8.4018 21.2498 9.7374 22.1402L16.0002 26.3162L22.263 22.1402C23.5986 21.2498 24.4002 19.7522 24.4002 18.1478V7.1246L16.0002 5.2598V5.2586ZM21.3426 11.4662L23.0406 13.163L15.4038 20.7998L10.3122 15.7082L12.009 14.0114L15.4026 17.405L21.3426 11.465V11.4662Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstDealImage2);
export default __webpack_public_path__ + "static/media/firstDealImage2.b444da2fe8c4b117a1bf21dfeaafd55a.svg";
export { ForwardRef as ReactComponent };